module.exports = __webpack_public_path__ + "img/album21_31.d2ad628d.jpg";